import {
  IDrawOverlays,
  IFindParameter,
  IOverlayDelete,
  IPolylineRangingParameter,
  IResult,
} from "@/types/map";

import * as turf from "@turf/helpers";
import centerOfMass from "@turf/center-of-mass";

declare let BMapGLLib: any;
declare let BMapGL: any;

declare const BMAP_DRAWING_MARKER: any; //画点
declare const BMAP_DRAWING_CIRCLE: any; //画圆
declare const BMAP_DRAWING_POLYLINE: any; //画线
declare const BMAP_DRAWING_POLYGON: any; //画多边形
declare const BMAP_DRAWING_RECTANGLE: any; //画矩形

export default class DrawOverlaysBD {
  private static intances: Map<string, any>;

  private _view!: any;
  private _generateId: Boolean = false;
  private _overlaysType!: String;
  private _clearLastResult: Boolean = false;
  private _drawOverlays: Map<string, Array<any>> = new Map<string, Array<any>>(); //type-Arrary(overlay) 键值对
  private _drawingType!: any;
  private _drawingManager!: any;
  private _drawCallback!: any;//回调返回特定结果
  private _model!: any;//绘制模式
  private _id: any;//覆盖物id
  private _symbol: any;//覆盖物符号样式
  private _repeat: any;//重复绘制
  private _fields: any;//属性字段
  private _calLabel: string = "";

  private DistanceTool: any;

  private _rightClickFunction: any; //响应右击事件

  public static defaultLineSymbol: Object = {
    strokeColor: "rgb(255,0,0)", //边线颜色。
    fillColor: "rgb(0,144,255)", //填充颜色。当参数为空时，圆形将没有填充效果。
    strokeWeight: 1, //边线的宽度，以像素为单位。
    strokeOpacity: 1, //边线透明度，取值范围0 - 1。
    strokeStyle: "solid", //边线的样式，solid或dashed。
    enableEditing: false, /////暂时没起到作用是因为DrawingManager.js源码有问题
  };

  public static defaultPolygonSymbol: Object = {
    strokeColor: "red", //边线颜色。
    fillColor: "#0080ff", //填充颜色。当参数为空时，圆形将没有填充效果。
    strokeWeight: 2, //边线的宽度，以像素为单位。
    strokeOpacity: 1, //边线透明度，取值范围0 - 1。
    fillOpacity: 1, //填充的透明度，取值范围0 - 1。
    strokeStyle: "solid", //边线的样式，solid或dashed。
    enableEditing: false, /////暂时没起到作用是因为DrawingManager.js源码有问题
  };

  public static defaultPicMarkerSymbol: any = {
    icon: {},
    enableDragging: false,
    offset: {
      width: 0,
      height: 0,
    },
    rotation: {},
    shadow: null,
    title: "",
  };

  public static defaultSimpleMarkerSymbol: Object = {
    icon: {
      anchor: {
        width: 0,
        height: 0,
      },
      size: {
        width: 24,
        height: 36,
      },
      imageUrl: "",
    },
    enableDragging: false,
    offset: {
      width: 0,
      height: 0,
    },
    // rotation:{},
    // shadow:null,
    // title:""
  };

  // private dataJsonMap: Map<string, any> = new Map();

  private constructor(view: any) {
    this._view = view;
  }

  public static getInstance(view: any) {
    let id = view.getContainer().id;
    if (!DrawOverlaysBD.intances) {
      DrawOverlaysBD.intances = new Map();
    }
    let intance = DrawOverlaysBD.intances.get(id);
    if (!intance) {
      intance = new DrawOverlaysBD(view);
      DrawOverlaysBD.intances.set(id, intance);
    }
    return intance;
  }

  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
    this._drawingType = params.drawType;
    this._model = params.model || "add";
    this._id = params.id || undefined;
    this._overlaysType = params.type || "drawOverlays";
    this._symbol = params.symbol || params.defaultSymbol;
    this._drawCallback = params.callback;
    this._repeat = params.repeat || params.onlyOnce === false || false;
    this._fields = params.fields;

    const enableCalculate = params.enableCalculate === true;//是否计算面积、长度

    //得到百度地图的符号选项
    let resultObj = this.processDefaultSymbol(this._drawingType, this._symbol);

    let drawSymbol = resultObj.symbolOption;
    let drawMode = resultObj.drawingMode;

    this._drawingManager = new BMapGLLib.DrawingManager(this._view, {
      enableCalculate: enableCalculate, // 绘制是否进行测距测面
      isOpen: true, //是否开启绘制模式
      drawingType: drawMode, //DrawingManager.js源码中用的是drawingMode。。。。
      enableDrawingTool: false, //是否显示工具栏
      markerOptions: drawSymbol, //点的样式
      circleOptions: drawSymbol, //圆的样式
      polylineOptions: drawSymbol, //线的样式
      polygonOptions: drawSymbol, //多边形的样式
      rectangleOptions: drawSymbol, //矩形的样式
    });

    this._drawingManager.open();
    this._drawingManager.setDrawingMode(drawMode);

    this._drawingManager.addEventListener('overlaycomplete',
      (results: any) => {
        if (enableCalculate) {
          this._calLabel = results.calculate.toString();
        }
        //解析绘制结果
        const result = this.onDrawComplete(results);
        if (this._drawCallback) {
          this._drawCallback(result);
        }

        if (this._repeat === true) {
          this.startDrawOverlays(params);
        } else {
          this.stopDrawOverlays();
        }

      }
    );

    if (this._drawingType === "point") {
      this._rightClickFunction = (event: any) => {
        this.stopDrawOverlays();
      }
      this._view.addEventListener("rightclick", this._rightClickFunction);
    }
  }


  public async deleteDrawOverlays(params: IOverlayDelete): Promise<IResult> {
    await this.stopDrawOverlays();
    if (this._calLabel != "") {
      let overlays = this._view.getOverlays();
      overlays.forEach((overlay: any) => {
        if (overlay instanceof BMapGL.Label) {
          if (overlay.content.toString() == this._calLabel) {
            this._view.removeOverlay(overlay);
            this._calLabel = "";
          }
        }
      });
    }
    if (this.DistanceTool) {
      this.clearPolylineRing();
    }
    let types: string[], ids: string[];
    let delCount: number = 0;
    if (!params) {
      this._drawOverlays.forEach((overlaysArray) => {
        overlaysArray.forEach((overlay: any) => {
          this._view.removeOverlay(overlay);
          delCount++;
        });
      });
      this._drawOverlays.clear();
    } else {
      types = params.types || [];
      ids = params.ids || [];
      delCount = 0;

      this._drawOverlays.forEach((overlaysArray, key) => {
        overlaysArray.forEach((overlay: any, index: number) => {
          if (
            //只判断type
            (types.length > 0 &&
              ids.length === 0 &&
              types.indexOf(overlay.type) >= 0) ||
            //只判断id
            (types.length === 0 &&
              ids.length > 0 &&
              ids.indexOf(overlay.id) >= 0) ||
            //type和id都要判断
            (types.length > 0 &&
              ids.length > 0 &&
              types.indexOf(overlay.type) >= 0 &&
              ids.indexOf(overlay.id) >= 0)
          ) {
            this._view.removeOverlay(overlay);
            delCount++;

            //overlaysArray.splice(index, 1);
            if (!overlaysArray.length) {
              this._drawOverlays.delete(key);
            }
          }
        });
      });
    }

    return {
      status: 0,
      message: "成功调用该方法！",
      result: `删除了${delCount}个覆盖物`,
    };
  }

  public async stopDrawOverlays(): Promise<IResult> {
    if (this._drawingManager) {
      this._drawingManager.close();
    }
    if (this._drawingType === "point") {
      this._view.removeEventListener("rightclick");
    }
    this._drawingType = null;
    if (this.DistanceTool) {
      this.DistanceTool.close();
    }

    this._generateId = false;
    this._overlaysType = "";
    this._drawingManager = undefined;
    this.DistanceTool = undefined;
    this._rightClickFunction = undefined;
    this._clearLastResult = false;
    this._calLabel = "";
    this._drawCallback = undefined;
    this._drawingType = "";
    this._model = "";
    this._id = "";
    this._symbol = undefined;
    this._repeat = false;
    this._fields = undefined;

    return {
      status: 0,
      message: "成功调用该方法！",
    };
  }

  public async getDrawOverlays(): Promise<IResult> {
    let overlays = new Array<any>();
    this._drawOverlays.forEach((drawOverlayArray: any, geoType: string) => {
      drawOverlayArray.forEach((ovl: any) => {
        overlays.push({
          id: ovl.id,
          type: ovl.type,
          symbol: ovl.symbol,
          fields: {
            id: ovl.id,
            type: ovl.type || "drawOverlays",
            ...ovl.fields,
          },
          geometry: ovl.geometry,
        });
      });
    });
    let data = {
      overlays: overlays,
      type: "drawOverlays",
    };
    let result = {
      data: data,
      dataJson: JSON.stringify(data),
    }
    return {
      status: 0,
      message: "成功调用改方法！",
      result: result,
    };
  }

  private processDefaultSymbol(
    drawType: string,
    defaultSymbol: any
  ): any {
    let symbolOption: any = null;
    let drawingMode = BMAP_DRAWING_MARKER; //default marker
    switch (drawType) {
      case "point":
        symbolOption = DrawOverlaysBD.defaultPicMarkerSymbol;
        // if(defaultSymbol && defaultSymbol.hasOwnProperty('url')){
        //   symbolOption.icon.imageUrl = defaultSymbol.url;
        // }
        if (
          defaultSymbol &&
          defaultSymbol.hasOwnProperty("size") &&
          defaultSymbol.size instanceof Array
        ) {
          let size = new BMapGL.Size(
            defaultSymbol.size[0],
            defaultSymbol.size[1]
          );
          let icon;
          if (defaultSymbol.anchor && defaultSymbol.anchor == "top") {
            icon = new BMapGL.Icon(defaultSymbol.url, size, {
              imageSize: size,
              anchor: new BMapGL.Size(
                defaultSymbol.size[0] / 2,
                defaultSymbol.size[1]
              ),
            });
          } else {
            icon = new BMapGL.Icon(defaultSymbol.url, size, {
              imageSize: size,
            });
          }

          symbolOption.icon = icon;
        }

        drawingMode = BMAP_DRAWING_MARKER;
        break;
      case "polyline":
        symbolOption = DrawOverlaysBD.defaultLineSymbol;
        if (defaultSymbol && defaultSymbol.hasOwnProperty("color")) {
          symbolOption.strokeColor = defaultSymbol.color;
        }
        if (defaultSymbol && defaultSymbol.hasOwnProperty("width")) {
          symbolOption.strokeWeight = defaultSymbol.width;
        }
        if (defaultSymbol && defaultSymbol.hasOwnProperty("style")) {
          const style = defaultSymbol.style === "dash" ? "dashed" : "solid";
          symbolOption.strokeStyle = style;
        }

        drawingMode = BMAP_DRAWING_POLYLINE;
        break;
      case "polygon":
      case "freehandPolygon":
      case "circle":
      case "rectangle":
        drawingMode = drawType;
        symbolOption = DrawOverlaysBD.defaultPolygonSymbol;
        if (defaultSymbol && defaultSymbol.hasOwnProperty("outline")) {
          const style =
            defaultSymbol.outline.style === "dash" ? "dashed" : "solid";
          symbolOption.strokeStyle = style;
          if (defaultSymbol.outline.color)
            symbolOption.strokeColor = defaultSymbol.outline.color;
          if (defaultSymbol.outline.opacity)
            symbolOption.strokeOpacity = defaultSymbol.outline.opacity;
          if (defaultSymbol.outline.width)
            symbolOption.strokeWeight = defaultSymbol.outline.width;
        }
        if (defaultSymbol && defaultSymbol.hasOwnProperty("color")) {
          symbolOption.fillColor = defaultSymbol.color;
        }
        if (defaultSymbol && defaultSymbol.hasOwnProperty("opacity")) {
          symbolOption.fillOpacity = defaultSymbol.opacity;
        }
        break;
      default:
        console.error("please input the correct drawType!");
        break;
    }

    return {
      drawingMode,
      symbolOption,
    };
  }

  private onDrawComplete(results: any) {
    const calculate = results.calculate;    //计算结果
    const drawMode = results.drawingMode;//绘制类型
    const label = results.label;
    let overlay = results.overlay;//绘制的覆盖物

    overlay.id = this._id;
    overlay.type = this._overlaysType;
    overlay.fields = this._fields;
    overlay.symbol = this._symbol;

    // //处理计算后的标签
    // if (calculate) {
    //   let overlays = this.view.getOverlays();
    //   overlays.forEach((overlay: any) => {
    //     if (overlay instanceof BMapGL.Label) {
    //       if (overlay.content.toString() == results.calculate) {
    //         let cont =
    //           (Number(overlay.content.toString()) / 1000000).toFixed(2) +
    //           "平方公里";
    //         overlay.setContent(cont);
    //         this.calLabel = cont;
    //       }
    //     }
    //   });
    // }

    let coordinates: any;
    let coordinatesRaw: any;
    let extent: any;
    let center: any;
    let radius: any;
    switch (drawMode) {
      case BMAP_DRAWING_MARKER:
        coordinates = this.point2Array(overlay.getPosition());
        coordinatesRaw = overlay.getPosition();
        center = this.point2Array(overlay.getPosition());
        break;
      case BMAP_DRAWING_CIRCLE:
        center = this.point2Array(overlay.getCenter());
        radius = overlay.getRadius();
        coordinates = {
          radius: radius,
          center: center,
        };
        break;
      case BMAP_DRAWING_POLYGON:
      case BMAP_DRAWING_RECTANGLE:
        center = this._calculateCenter(overlay.getPath());
      case BMAP_DRAWING_POLYLINE:
        coordinates = [new Array<Number>()];
        overlay.getPath().forEach((element: any) => {
          coordinates[0].push(this.point2Array(element));
        });
        extent = overlay.getBounds(); //@todo 暂不与arcgis保持一致
        coordinatesRaw = overlay.getPath();
        break;
      default:
        break;
    }

    let geo = {
      coordinates: coordinates,
      coordinatesRaw: coordinatesRaw, //百度地图原生坐标数据
      type: drawMode,
      extent: extent,
      center: center,
      centroid: center,
      radius: radius,
      //与arcgis保持同样的参数
      paths: drawMode === BMAP_DRAWING_POLYLINE ? coordinates : [],
      rings: drawMode === BMAP_DRAWING_POLYGON ? coordinates : [],
    }

    overlay.geometry = geo;

    //回调参数
    let callbackResult = {
      geometry: geo,
      center: center,//几何中心
      data: {
        type: "drawOverlays",
        overlays: [
          {
            geometry: geo,
            fields: {
              id: overlay.id,
              type: overlay.type || "drawOverlays",
              ...overlay.fields,
            },
            id: overlay.id,
            symbol: overlay.symbol,
          },
        ],
      },
    };

    let thisTypeOverlays: Array<any> | undefined = this._drawOverlays.get(this._drawingType);
    thisTypeOverlays = thisTypeOverlays || [];
    if (this._clearLastResult) {
      if (thisTypeOverlays && thisTypeOverlays.length) {
        let lastOverlay = thisTypeOverlays.pop();
        this._view.removeOverlay(lastOverlay);
        this._drawOverlays.set(this._drawingType, thisTypeOverlays);
      }
    }
    thisTypeOverlays.push(overlay);
    this._drawOverlays.set(this._drawingType, thisTypeOverlays);

    return callbackResult;
  }

  public async findOverlays(params: IFindParameter): Promise<IResult> {
    let type = params.layerName;
    let ids = params.ids || [];
    let level = params.level || this._view.getZoom();
    let overlays = this._view.getOverlays();
    let findCount = 0;

    let centerResult = params.centerResult;
    let _this = this;

    for (let overlay of overlays) {
      await overlayAnimation(overlay);
    }

    async function overlayAnimation(overlay: any) {
      if (type == overlay.type && ids.indexOf(overlay.id) >= 0) {
        if (centerResult) {
          let center = overlay.getPosition();
          if (center.lat !== null && center.lng !== null) {
            await _this._view.centerAndZoom(overlay.getPosition(), level);
          }
        }
        overlay.setAnimation(2);
        await sleep();
        overlay.setAnimation(0);
        findCount++;
      }
    }

    async function sleep() {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(null);
        }, 3000);
      });
    }

    return {
      message: "成功调用该方法！",
      status: 0,
      result: `成功发现${findCount}个覆盖物`,
    };
  }

  public async polylineRanging(
    params: IPolylineRangingParameter
  ): Promise<IResult> {
    this.stopDrawOverlays();
    const unit = params ? params.unit : undefined;
    const lineSymbol = params ? params.lineSymbol : undefined;
    const callback = params ? params.callback : undefined;

    let lineStroke, lineColor, opacity, lineStyle;
    if (lineSymbol) {
      ({
        width: lineStroke,
        color: lineColor,
        opacity: opacity,
        style: lineStyle,
      } = lineSymbol);
    }

    const pathStart = "assets/mapIcons/icon_start.png";
    const pathMid = "assets/mapIcons/icon_way.png";
    const pathEnd = "assets/mapIcons/icon_end.png";
    const imageSize = new BMapGL.Size(23, 37); //图片长宽
    const imageExtend = new BMapGL.Size(23, 37);
    let myDistanceToolObject = new BMapGLLib.DistanceTool(this._view, {
      lineStroke: lineStroke || 4,
      lineColor: lineColor || "#87CEEB",
      opacity: opacity || 1,
      lineStyle: lineStyle || "dashed",
      clearLastResult: true,
      secIcon: new BMapGL.Icon(pathMid, imageExtend, {
        imageSize: imageSize,
        anchor: new BMapGL.Size(11, 37),
      }),
      startIcon: new BMapGL.Icon(pathStart, imageExtend, {
        imageSize: imageSize,
        anchor: new BMapGL.Size(11, 37),
      }),
    });
    myDistanceToolObject.open();
    this.DistanceTool = myDistanceToolObject;
    myDistanceToolObject.addEventListener("addpoint", (e: any) => {
      this.onPointAdded(e);
    });
    myDistanceToolObject.addEventListener("drawend", (e: any) => {
      let ptOverlays = myDistanceToolObject._dots;
      ptOverlays[ptOverlays.length - 1].setIcon(
        new BMapGL.Icon(pathEnd, imageExtend, {
          imageSize: imageSize,
          anchor: new BMapGL.Size(11, 37),
        })
      );
    });

    return {
      status: 0,
      message: "not complete",
    };
  }

  private clearPolylineRing() {
    let htmlEls: HTMLCollectionOf<Element> = document.getElementsByClassName(
      "BMap_Marker BMap_noprint"
    );
    let elclicks = [];
    for (let i = 0; i < htmlEls.length; i++) {
      let el: any = htmlEls[i];
      console.log("el.title", el.title);
      if (el.title == "清除本次测距") {
        elclicks.push(el);
      }
    }
    elclicks.forEach((els) => {
      els.click();
    });
  }

  private async onPointAdded(params: any): Promise<any> { }

  //百度point转为数组
  private point2Array(point: any): Array<Number> {
    let res = new Array<Number>(2);
    res[0] = point.lng;
    res[1] = point.lat;
    return res;
  }

  //计算多边形的质心
  private _calculateCenter(coords: any): Array<Number> {
    const rings = coords.map((point: any) => [point.lng, point.lat]);
    //把第一个点复制到最后形成闭环
    rings.push(rings[0]);
    const turfPolygon = turf.polygon([rings]);
    let center = centerOfMass(turfPolygon);
    let tm = center.geometry.coordinates;
    return tm;
  }
}
